import each from "lodash/fp/each";
import isFunction from "lodash/fp/isFunction";

class Controller {
  constructor(Events, $element, $timeout) {
    "ngInject";

    this.selectedStepIndex = 0;
    this.steps = [];
    this.forms = {};
    this.verticalStyle = {};

    this.Events = Events;
    this.$element = $element;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.switchViewAction = isFunction(this.switchViewAction)
      ? this.switchViewAction
      : angular.noop;
  }

  // Handle Steps Insertion/ Deletion
  addToSteps(step) {
    const index = this.getStepIndex(step);
    this.steps.splice(index, 0, step);
    this.setActive();
  }

  removeFromSteps(step) {
    const index = this.getStepIndex(step);
    this.steps.splice(index, 1);

    this.setActive();
  }

  getStepIndex({ $element }) {
    const steps = this.$element.find("form-step");
    return Array.prototype.indexOf.call(steps, $element[0]);
  }

  // Handle stepper controls and dynamic styling
  goForward() {
    if (this.selectedStepIndex < this.steps.length - 1) {
      this.selectedStepIndex++;
      this.updateStyle(this.selectedStepIndex - 1, this.selectedStepIndex);
      this.switchViewAction(this.selectedStepIndex);
      this.onClickForward(this.selectedStepIndex);
    }
  }

  goBack() {
    if (this.selectedStepIndex > 0) {
      this.selectedStepIndex--;
      this.updateStyle(this.selectedStepIndex + 1, this.selectedStepIndex);
      this.switchViewAction(this.selectedStepIndex);
    }
  }

  updateStyle(oldStep, newStep) {
    this.setActive();
    this.animateHeight(oldStep, newStep);
  }

  setActive() {
    const noCapEach = each.convert({ cap: false });
    noCapEach((step, index) => {
      const selectedStep = this.steps[this.selectedStepIndex];
      step.toggleActive(step === selectedStep, index < this.selectedStepIndex);
    })(this.steps);
  }

  animateHeight(oldStep, newStep) {
    const oldSelectedStep = this.steps[oldStep].$element[0].clientHeight;
    const selectedStepHeight = this.steps[newStep].$element[0].clientHeight;
    this.verticalStyle.height = `${oldSelectedStep}px`;

    this.$timeout(() => {
      this.verticalStyle.height = `${selectedStepHeight}px`;
    });

    this.$timeout(() => {
      this.verticalStyle.height = null;
    }, 500);
  }

  hasNext() {
    return this.selectedStepIndex < this.steps.length - 1;
  }

  hasPrevious() {
    return this.selectedStepIndex !== 0;
  }

  isDisabled() {
    const selectedStepUniqueFormId = this.steps[this.selectedStepIndex]
      .uniqueFormId;
    const selectedForm = this.forms[selectedStepUniqueFormId];
    return selectedForm.$invalid;
  }

  confirm() {
    this.Events.emit(this.confirmEvent, this.model);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/formStepper/formStepper.controller.js